import { memo } from 'react';
import { Modal } from '@betty/navigation';
import { useLocation, Location, NavigateFunction } from 'react-router';
import useNavigation from './hooks/useNavigation/useNavigation';

export default {
  navigate: (screen, params) => {
    history.navigate?.(screen, params);
  },
  getCurrentRoute: () => {
    const modal = Modal.getCurrentModal();

    return { name: modal || history.location?.pathname };
  },
};

type History = {
  navigate?: NavigateFunction;
  location?: Location;
};

export const history: History = {};

const NavigationRefBaseComponent = () => {
  const navigation = useNavigation();

  history.navigate = navigation.navigate;
  history.location = useLocation();

  return null;
};

NavigationRefBaseComponent.displayName = 'NavigationRefBaseComponent';

export const NavigationRefComponent = memo(NavigationRefBaseComponent);
